import { createSignal } from "solid-js";

// Global singleton signal
const localStorageKey = "color";
let _color: () => string;
let _setColor: (v: string) => void;

function init() {
  let saved = "color-blue";

  try {
    const raw = localStorage.getItem(localStorageKey);
    if (raw !== null) {
      saved = JSON.parse(raw);
    } else {
      localStorage.setItem(localStorageKey, JSON.stringify(saved));
    }
  } catch (e) {
    console.warn("Failed to read color from localStorage", e);
  }

  const [color, setColorSignal] = createSignal<string>(saved);

  const setColor = (v: string) => {
    setColorSignal(v);
    try {
      localStorage.setItem(localStorageKey, JSON.stringify(v));
    } catch (e) {
      console.warn("Failed to write color to localStorage", e);
    }

    // Update <body> class
    document.body.classList.forEach((cls) => {
      if (cls.startsWith("color-")) document.body.classList.remove(cls);
    });
    document.body.classList.add(v);
  };

  _color = color;
  _setColor = setColor;
}

// Initialize once
if (!_color || !_setColor) {
  init();
}

/**
 * Refresh signal from localStorage
 * Bisa dipanggil misal saat login/refresh page
 */
export function refreshColorFromLocalStorage() {
  if (!_setColor) return;
  try {
    const raw = localStorage.getItem(localStorageKey);
    if (raw !== null) {
      _setColor(JSON.parse(raw));
    }
  } catch (e) {
    console.warn("Failed to refresh color from localStorage", e);
  }
}

export function useColor() {
  return [_color, _setColor] as const;
}
